import React, { useEffect, useState } from "react"
import { Layout, Alert, Form, Button, Space, notification } from "antd"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"

/* CUSTOM COMPONENT */
import LoginHeader from '../../component/LoginHeader/LoginHeader';
import { SiteLayoutBackground, Left, Right, LoginBox, XContent, SignIn, TextBox, XButton, FormItem, SignUpDiv, SignUpLink, SocialButton, ResendOtp } from "./ForgotPasswrodStyle"

/* Actions */
import { sendOtpForForgotPassword, sendOtpForForgotPasswordResetState } from '../../action/sendOtpForForgotPasswordAction'
import { resetForgotPassword, resetForgotPasswordResetState } from '../../action/resetForgotPasswordAction'

const { Footer } = Layout;

const ForgotPassword = props => {

    /* variable & state */
    const {
        sendOtpForForgotPassword, sendOtpForForgotPasswordState, sendOtpForForgotPasswordResetState,
        resetForgotPassword, resetForgotPasswordState, resetForgotPasswordResetState,
    } = props

    const [formData, setFormData] = useState({
        email: "",
        password: "",
        confirm_password: "",
        otp: "",
    })
    const [redirect, setRedirect] = useState(false)

    /* Callback */
    useEffect(() => {
        return (() => {
            sendOtpForForgotPasswordResetState()
            resetForgotPasswordResetState()
        })
    }, [])
    useEffect(() => {
        if (resetForgotPasswordState.apiState === "success") {
            notification["success"]({
                message: resetForgotPasswordState.message,
            })
            setRedirect(true)
        }
        else if (resetForgotPasswordState.apiState === "error") {
            notification["error"]({
                message: resetForgotPasswordState.message,
            })
        }
    }, [resetForgotPasswordState])

    useEffect(() => {
        if (sendOtpForForgotPasswordState.apiState === "success") {
            notification["success"]({
                message: sendOtpForForgotPasswordState.message,
            })
        }

    }, [sendOtpForForgotPasswordState])

    /* function */
    const handleOnChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const onFormSubmit = () => {
        if (sendOtpForForgotPasswordState.apiState === "success") {
            resetForgotPassword(formData)
        }
        else {
            sendOtpForForgotPassword(formData)
        }
    }

    return (
        <>
            {redirect &&
                <Redirect to="/" />
            }
            <Layout style={{ backgroundColor: "#fff" }}>
                {/* <LoginHeader /> */}
                <XContent className="site-layout" style={{ padding: '0 50px' }}>
                    <SiteLayoutBackground >
                        <Left>
                            <LoginBox>
                                <SignIn>Reset Password</SignIn>
                                {sendOtpForForgotPasswordState.apiState === "error" &&
                                    <Alert style={{ marginBottom: 8 }} message={sendOtpForForgotPasswordState.message} type="error" showIcon />}

                                <Form layout="vertical" onFinish={onFormSubmit}>
                                    <FormItem
                                        label="Email"
                                        name="email"
                                        rules={[
                                            { required: true, message: 'Please enter email id' },
                                            { type: 'email', message: 'Email is not valid' },
                                        ]}
                                    >
                                        <TextBox
                                            name="email"
                                            onChange={handleOnChange}
                                            size="large"
                                            readOnly={sendOtpForForgotPasswordState.apiState === "success"}
                                        />
                                    </FormItem>

                                    {sendOtpForForgotPasswordState.apiState === "success" &&
                                        <>
                                            <FormItem>
                                                <ResendOtp onClick={() => sendOtpForForgotPasswordResetState()}>Use other email</ResendOtp>
                                            </FormItem>
                                            <FormItem
                                                label="OTP"
                                                name="otp"
                                                rules={[
                                                    { required: true, message: 'Please enter valid OTP' },
                                                ]}
                                            >
                                                <TextBox
                                                    name="otp"
                                                    onChange={handleOnChange}
                                                    size="large"
                                                />
                                            </FormItem>
                                            <FormItem>
                                                <ResendOtp onClick={() => sendOtpForForgotPassword(formData)}>Resend otp?</ResendOtp>
                                            </FormItem>
                                            <FormItem
                                                label="Password"
                                                name="password"
                                                rules={[
                                                    { required: true, message: 'Please enter new password' },
                                                    { pattern: "^(?=.{8,})", message: 'Password should be at least 8 characters long' }
                                                ]}
                                            >
                                                <TextBox.Password name="password" onChange={handleOnChange}
                                                    size="large"
                                                />
                                            </FormItem>
                                            <FormItem
                                                label="Confirm Password"
                                                name="confirm_password"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please enter confirm password',
                                                    },
                                                    ({ getFieldValue }) => ({
                                                        validator(rule, value) {
                                                            if (!value || getFieldValue('password') === value) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject('Passwords do not match');
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <TextBox.Password name="confirm_password" onChange={handleOnChange}
                                                    size="large"
                                                />
                                            </FormItem>
                                        </>
                                    }
                                    <FormItem>
                                        <ResendOtp to={"/"}>Login</ResendOtp>

                                        {sendOtpForForgotPasswordState.apiState === "success" ?
                                            <XButton htmlType="submit" type="primary"
                                                className="borderPrimary"
                                                size="large"
                                                loading={resetForgotPasswordState.apiState === "loading" ? true : false}
                                            >Reset Password</XButton>
                                            :
                                            <XButton htmlType="submit" type="primary"
                                              className="borderPrimary"
                                                size="large"
                                                loading={sendOtpForForgotPasswordState.apiState === "loading" ? true : false}
                                            >Send OTP</XButton>
                                        }
                                    </FormItem>
                                </Form>
                            </LoginBox>
                        </Left>
                        <Right>
                            <img height='100%' width='100%' src={process.env.PUBLIC_URL + "/images/svg/DoctorLogin.svg"} alt="" />
                        </Right>
                    </SiteLayoutBackground>
                </XContent>
                {/* <Footer style={{ textAlign: 'center', position: "fixed", bottom: 0, width: "100%", backgroundColor: "#15558d", color: "#fff" }}>Lilac Insights ©2021</Footer> */}
            </Layout>
        </>
    )
}

const mapStateToProps = (state) => ({
    sendOtpForForgotPasswordState: state.sendOtpForForgotPassword,
    resetForgotPasswordState: state.resetForgotPassword,
})

const mapDispatchToProps = (dispatch) => ({
    sendOtpForForgotPassword: (params) => dispatch(sendOtpForForgotPassword(params)),
    sendOtpForForgotPasswordResetState: () => dispatch(sendOtpForForgotPasswordResetState()),
    resetForgotPassword: (params) => dispatch(resetForgotPassword(params)),
    resetForgotPasswordResetState: () => dispatch(resetForgotPasswordResetState()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
